// extracted by mini-css-extract-plugin
export var section = "_31-1";
export var topNav = "_31-0";